import { useCallback } from 'react';
import { Eye, Trash2 } from 'react-feather';
import { Dropdown } from 'semantic-ui-react';
import { IPolicy } from 'types';
import styles from './policiesList.scss';

interface IProps {
  containerId?: string;
  id: string;
  isUnfinished?: boolean;
  isOwner: boolean;
  isInReview?: boolean;
  showDelete?: boolean;
  viewBtnText?: string;
  setDeleted(id: string): void;
  viewPolicy(p: IPolicy): void;
}

const ActionsMenu = ({
  containerId,
  id,
  setDeleted,
  viewPolicy,
  isUnfinished,
  isOwner,
  isInReview,
  showDelete,
  viewBtnText = 'View policy',
}: IProps) => {
  const handleDelete = useCallback(() => setDeleted(id), [id, setDeleted]);

  if (isUnfinished && !isOwner) {
    return null;
  }

  return (
    <Dropdown
      id={containerId}
      icon="ellipsis vertical"
      floating={true}
      labeled={true}
      className={styles.action}
    >
      <Dropdown.Menu style={{ minHeight: showDelete ? 150 : 110 }}>
        <Dropdown.Header>View option</Dropdown.Header>
        <Dropdown.Item
          id={`${containerId}_View`}
          className={styles.actionItem}
          onClick={viewPolicy}
        >
          <Eye />
          {isUnfinished && !isInReview ? 'Setup' : viewBtnText}
        </Dropdown.Item>
        {showDelete && (
          <Dropdown.Item
            id={`${containerId}_Delete`}
            className={styles.actionItem}
            onClick={handleDelete}
          >
            <Trash2 />
            Delete
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ActionsMenu;
